import { render } from "./AppHeader2.vue?vue&type=template&id=4d290170"
import script from "./AppHeader2.vue?vue&type=script&lang=js"
export * from "./AppHeader2.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__